import { render, staticRenderFns } from "./Part-1-new.vue?vue&type=template&id=0162e5ce&"
import script from "./Part-1-new.vue?vue&type=script&lang=js&"
export * from "./Part-1-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports